<template>
  <div>
    <!-- 批量设置货架使用人：只改使用人属性和具体范围 -->
    <el-dialog :title="isBatch ? $t('message.batchSetShelfUser') : $t('message.setShelfUser')" :close-on-click-modal="false"
      :visible.sync="dialogVisible" width="520px" center>
      <div class="content">
        <el-form :model="form" :rules="rules" ref="form" label-width="120px">
          <!-- 单条时展示货架信息，批量时只改使用人属性和具体范围 -->
          <el-form-item v-if="!isBatch" :label="$t('message.shelfNumber') + '：'">
            {{ form.shelf_number }}
          </el-form-item>
          <!-- 使用人属性 -->
          <el-form-item :label="$t('message.userAttribute') + '：'" prop="range_type">
            <el-radio-group v-model="form.range_type" @change="onRangeTypeChange">
              <el-radio :label="2">{{ $t("message.publicShelf") }}</el-radio>
              <el-radio :label="1">{{ $t("message.personalShelf") }}</el-radio>
            </el-radio-group>
          </el-form-item>
          <!-- 具体范围：公共货架选组织，个人货架从账号列表选择人员 -->
          <el-form-item :prop="form.range_type == 1 ? 'admin_id' : 'org_id'">
            <span slot="label">
              <el-tooltip effect="dark" :content="$t('message.shelfUserRangeTip')" placement="right">
                <span>{{ $t('message.specificRange') }}：</span>
              </el-tooltip>
            </span>
            <el-select v-if="form.range_type == 1" v-model="form.admin_id"
              :placeholder="$t('message.specificRange')" filterable clearable>
              <el-option v-for="item in adminList" :key="item.id" :label="item.realname" :value="item.id">
              </el-option>
            </el-select>
            <el-cascader v-else filterable v-model="orgPath" :options="adminOrganization" :props="{
              expandTrigger: 'hover',
              label: 'name',
              value: 'id',
              children: 'childs',
              checkStrictly: true,
            }" :placeholder="$t('message.specificRange')" clearable @change="onOrgChange"></el-cascader>
          </el-form-item>
          <el-form-item v-if="!isBatch" :label="$t('message.owningRegion') + '：'">
            {{ areaText }}
          </el-form-item>
          <el-form-item v-if="!isBatch" :label="$t('message.shelfLayerNumber') + '：'">
            {{ form.shelf_floor }}层
          </el-form-item>
          <el-form-item v-if="!isBatch" :label="$t('message.shelfSizeMeters') + '：'">
            {{ $t("message.length") }} {{ form.c }} 米
            {{ $t("message.width") }} {{ form.k }} 米
            {{ $t("message.height") }} {{ form.g }} 米
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="save">{{ $t("message.save") }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
export default {
  data() {
    return {
      dialogVisible: false,
      isBatch: false,
      list: [],
      form: {
        range_type: 2,
        org_id: '',
        admin_id: '',
      },
      orgPath: [],
      adminOrganization: [],
      adminList: [],
      rules: {
        range_type: [
          { required: true, message: this.$t("message.TheRequired"), trigger: "change" },
        ],
        org_id: [
          { required: true, message: this.$t("message.TheRequired"), trigger: "change" },
        ],
        admin_id: [
          { required: true, message: this.$t("message.TheRequired"), trigger: "change" },
        ],
      },
    }
  },
  computed: {
    areaText() {
      const type = this.form.wms_area && this.form.wms_area.wms_area_type
      if (!type) return this.form.area_number || ''
      return type.code ? type.type + '-' + type.code : type.type
    },
  },
  created() {
    this.loadAdminOrganization()
  },
  methods: {
    open(item) {
      this.isBatch = false
      this.list = [item]
      this.form = JSON.parse(JSON.stringify(item || {}))
      this.form.range_type = Number(this.form.range_type)
      if (!this.form.org_id && item.organization) {
        this.form.org_id = item.organization.id
      }
      if (!this.form.admin_id && item.admin) {
        this.form.admin_id = item.admin.id
      }
      this.orgPath = []
      this.dialogVisible = true
      this.$nextTick(() => {
        if (this.$refs.form) this.$refs.form.clearValidate()
      })
      if (this.form.range_type == 2 && this.form.org_id) {
        this.$api.roleApi.getPOrgIds({ org_id: this.form.org_id }).then((res) => {
          this.orgPath = res.data
        })
      }
      if (this.form.range_type == 1) this.loadAdminList()
    },
    openBatch(list) {
      this.isBatch = true
      this.list = list || []
      this.form = {
        range_type: 2,
        org_id: '',
        admin_id: '',
      }
      this.orgPath = []
      this.dialogVisible = true
      this.$nextTick(() => {
        if (this.$refs.form) this.$refs.form.clearValidate()
      })
    },
    loadAdminOrganization() {
      this.$api.roleApi.getAdminOrganization().then((res) => {
        this.adminOrganization = res.data || []
      })
    },
    // 个人货架只展示当前账号权限范围内的人员，避免选择到权限外账号。
    loadAdminList() {
      this.$api.getAuthWorkGroupAdminDepart({ format_list: 1 }).then((res) => {
        this.adminList = res.data || []
      })
    },
    onRangeTypeChange(rangeType) {
      this.form.org_id = ''
      this.form.admin_id = ''
      this.orgPath = []
      if (rangeType == 1) this.loadAdminList()
    },
    onOrgChange(val) {
      this.form.org_id = val && val.length ? val[val.length - 1] : ''
    },
    // 与货架修改弹窗保持相同参数格式，并在原货架数据上只覆盖使用人设置。
    buildPayload(item) {
      const data = {
        ...item,
        range_type: this.form.range_type,
        org_id: this.form.range_type == 2 ? this.form.org_id : '',
        admin_id: this.form.range_type == 1 ? this.form.admin_id : '',
      }
      delete data.shelf_grid
      delete data.create_count
      ;(item.floor_grids || []).forEach((row) => {
        data['shelf_grid[' + row.floor + ']'] = row.grid_count
      })
      return data
    },
    save() {
      this.$refs.form.validate((valid) => {
        if (!valid) return
        const requests = []
        this.list.forEach((item) => {
          requests.push(this.$api.warehouseApi.shelfUpdate(this.buildPayload(item)))
        })
        Promise.all(requests).then((res) => {
          this.$message.success(res[0] && res[0].msg)
          this.dialogVisible = false
          this.$emit('saved')
        })
      })
    },
  },
}
</script>
<style lang="scss" scoped>
.content {
  padding: 0 15px;

  .el-select {
    width: 100%;
  }

  /deep/.el-cascader {
    width: 100%;
  }
}
</style>
